function normalizeAcceptLanguage(locale) {
  return locale === 'en' || locale === 'en-US' ? 'en-US' : 'zh-CN';
}
function applyAcceptLanguageHeader(config, locale) {
  config.headers = config.headers || {};
  delete config.headers.language;
  config.headers['Accept-Language'] = normalizeAcceptLanguage(locale);
  return config;
}
module.exports = {
  applyAcceptLanguageHeader: applyAcceptLanguageHeader,
  normalizeAcceptLanguage: normalizeAcceptLanguage
};